<script>
export default {
  computed: {
    propValidationIsValid: function () {
      const options = this.$options.props
      const values = this.$props
      let isValid = true
      for (let key in options) {
        if (isValid) {
          let k = options[key]
          let v = values[key] || k.default || undefined
          if (v !== undefined || v !== null) {
            if (isValid && k.hasOwnProperty('type')) {
              // eslint-disable-next-line
              isValid = (k.type.name.toLowerCase() === typeof v)
            }
            if (isValid && k.hasOwnProperty('validator')) {
              isValid = (k.validator(v))
            }
          } else if (k.hasOwnProperty('required') && k.required === true) {
            isValid = false
          }
        }
      }
      return isValid
    }
  }
}
</script>
